export const getLayerStrokeDashes = (layer) => {
  if (!layer.strokeDashes) {
    return [];
  }

  return layer.strokeDashes;
};
